<template>
  <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="18" height="18" viewBox="0 0 18 18">
    <g transform="translate(-250 -1916)">
      <g transform="translate(250 1918.769)">
        <path class="a"
              d="M21.228,10.34l-4.656,4.742a.084.084,0,0,0,0,.121l3.258,3.47a.561.561,0,0,1,0,.8.564.564,0,0,1-.8,0l-3.245-3.457a.089.089,0,0,0-.125,0l-.792.8a3.484,3.484,0,0,1-2.484,1.047,3.554,3.554,0,0,1-2.536-1.077l-.762-.774a.089.089,0,0,0-.125,0L5.72,19.469a.564.564,0,0,1-.8,0,.561.561,0,0,1,0-.8L8.182,15.2a.092.092,0,0,0,0-.121L3.522,10.34a.085.085,0,0,0-.147.061v9.487A1.389,1.389,0,0,0,4.76,21.273H19.99a1.389,1.389,0,0,0,1.385-1.384V10.4A.087.087,0,0,0,21.228,10.34Z"
              transform="translate(-3.375 -8.811)"/>
        <path class="a"
              d="M12.7,15.807a2.351,2.351,0,0,0,1.692-.71l6.788-6.918a1.359,1.359,0,0,0-.857-.3H5.082a1.35,1.35,0,0,0-.857.3L11.014,15.1A2.351,2.351,0,0,0,12.7,15.807Z"
              transform="translate(-3.702 -7.875)"/>
      </g>
      <path class="b" d="M0,0H18V18H0Z" transform="translate(250 1916)"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: "Envelope"
}
</script>

<style scoped>
.icon .a {
  fill: none;
}

.icon .b {
  fill: #00a2f8;
}
</style>